(function ($) {
    $('.block-career__job__title').on('click', function (event) {
        event.preventDefault();
        
        if (!$(this).hasClass('open')) {
            $('.block-career__job__title.open').each(function () {
                $(this).next('.block-career__job__info').slideToggle();
                $(this).toggleClass('open');
            });
        }

        $(this).next('.block-career__job__info').slideToggle();
        $(this).toggleClass('open');
    })

    $('.block-career__btn-postuler').on('click', function () {
        $('.gfield.select_jobs select').val($(this).data('job'));
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#block-career__form').offset().top - 75,
        }, 1000);
    })

    // Select jobs on anchor
    const hash = window.location.hash.substr(1);
    if (hash !== '' && hash !== 'contact') {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("h3[data-name='" + hash + "']").offset().top - 75,
        }, 750).promise().then(() => {
            $("h3[data-name='" + hash + "']").click();
        });
    }
}(jQuery))
